module.exports = __webpack_public_path__ + "img/6.d633fb99.jpg";